/* =========================================================
   PRE-LAUNCH SIGN-UP PAGE (/launch) — behaviour (no dependencies)

   CONFIG  <script type="application/json" id="PLConfig"> from sections/pl-launch.liquid:
           listId, companyId (Klaviyo public key), metric, source, launchAt (ISO date with zone).
   FORM    [data-pl-form] is a plain form (shown by this script): the email joins the Klaviyo list
           and fires the metric with the first name (same calls as assets/t21-gift.js). It is not a
           Shopify customer form on purpose (Shopify puts hCaptcha on those). If Klaviyo is unreachable
           the hidden Shopify form [data-pl-backup] (tags newsletter,launch-waitlist) is posted instead,
           so the address is never lost. Without JS a <noscript> Shopify form is shown.
           The joined state is shown in place and remembered for this browser.
   VIDEO   video[data-pl-video] (wide/narrow) plays muted over the photo; only the one for this screen
           is loaded, none with reduced motion or data saver. Fades in once it actually plays, and the
           photo under it fades out (.pl__media.is-video).
   COUNT   [data-pl-count] counts down to launchAt and hides at zero.
   TRACKING dataLayer + Shopify custom pixel event "launch_signup" on submit (map to Meta "Lead"
           in GTM), plus fbq('track', 'Lead') once the sign-up went through, when a Meta pixel is on the page.
   ========================================================= */
(function () {
  if (window.__plLaunch) return;
  window.__plLaunch = true;

  var cfg = {};
  try { cfg = JSON.parse((document.getElementById('PLConfig') || {}).textContent || '{}'); } catch (e) {}
  var KEY = 'pl_launch_joined';

  function store(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
  function stored() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }

  function track(name, data) {
    data = data || {};
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, data)); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
  }

  /* ---------- joined state ---------- */
  function showJoined(name, focus) {
    var title = document.querySelector('[data-pl-joined-title]');
    if (title) {
      var tpl = title.getAttribute('data-template') || '';
      title.textContent = name
        ? tpl.replace('[name]', name)
        : tpl.replace(/,?\s*\[name\]/, '').replace(/\s+([.!])/, '$1');
    }
    document.querySelectorAll('[data-pl-unjoined]').forEach(function (el) { el.hidden = true; });
    document.querySelectorAll('[data-pl-joined]').forEach(function (el) {
      el.hidden = false;
      if (focus) el.focus({ preventScroll: true });
    });
  }

  /* fetch with a timeout, so a stalled request never leaves the button stuck */
  function post(url, body, ms) {
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, ms || 8000) : 0;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' },
      body: JSON.stringify(body),
      signal: ctl ? ctl.signal : undefined
    }).then(function (r) {
      clearTimeout(timer);
      if (!(r.ok || r.status === 202)) throw new Error('klaviyo ' + r.status);
      return r;
    }, function (e) { clearTimeout(timer); throw e; });
  }

  /* ---------- form ---------- */
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function bindForm() {
    var form = document.querySelector('form[data-pl-form]');
    if (!form || form.hasAttribute('data-pl-bound')) return;
    form.setAttribute('data-pl-bound', '');
    form.hidden = false;
    var input = form.querySelector('[data-pl-email]');
    var nameInput = form.querySelector('[data-pl-name]');
    var btn = form.querySelector('button[type="submit"]');
    var err = form.querySelector('[data-pl-error]');

    function setError(text) {
      if (err) err.textContent = text || '';
      if (input) input.setAttribute('aria-invalid', text ? 'true' : 'false');
    }
    function busy(on) {
      if (!btn) return;
      btn.setAttribute('aria-busy', on ? 'true' : 'false');
      btn.disabled = !!on;
    }
    function done(name) {
      busy(false);
      try { if (typeof window.fbq === 'function') window.fbq('track', 'Lead', { content_name: 'Pre-launch waitlist' }); } catch (x) {}
      store(name || '-');
      showJoined(name, true);
    }
    /* Klaviyo unreachable: save the person as a Shopify customer (tagged launch-waitlist) in the
       background; if even that fails, post the form normally (the page reloads in the joined state). */
    var backup = document.querySelector('form[data-pl-backup]');
    function shopifyFallback(name) {
      if (!backup) { busy(false); setError('Something went wrong. Please try again.'); return; }
      backup.querySelector('[data-pl-backup-email]').value = (input && input.value || '').trim();
      backup.querySelector('[data-pl-backup-name]').value = name || '';
      var ctl = window.AbortController ? new AbortController() : null;
      var timer = ctl ? setTimeout(function () { ctl.abort(); }, 10000) : 0;
      fetch(backup.action, { method: 'POST', body: new FormData(backup), credentials: 'same-origin', signal: ctl ? ctl.signal : undefined })
        .then(function (r) {
          clearTimeout(timer);
          if (!r.ok || !/[?&]customer_posted=true/.test(r.url || '')) throw new Error('shopify form');
          done(name);
        })
        .catch(function () {
          clearTimeout(timer);
          busy(false);
          store(name || '-');
          try { backup.submit(); } catch (x) { setError('Something went wrong. Please try again.'); }
        });
    }

    input && input.addEventListener('input', function () { if (input.getAttribute('aria-invalid') === 'true') setError(''); });

    form.addEventListener('submit', function (e) {
      var email = (input && input.value || '').trim();
      var name = (nameInput && nameInput.value || '').trim().slice(0, 60);
      if (!EMAIL.test(email)) {
        e.preventDefault();
        setError('Please enter a valid email address.');
        input && input.focus();
        return;
      }
      setError('');
      track('launch_signup', { source: cfg.source || '' });
      e.preventDefault();
      if (!window.fetch) { /* very old browser: plain post of the Shopify backup form */
        store(name || '-');
        if (backup) { backup.querySelector('[data-pl-backup-email]').value = email; backup.querySelector('[data-pl-backup-name]').value = name; backup.submit(); }
        return;
      }
      busy(true);
      if (!cfg.listId || !cfg.companyId) { shopifyFallback(name); return; }

      var q = '?company_id=' + encodeURIComponent(cfg.companyId);
      var attrs = { email: email };
      if (name) attrs.first_name = name;
      post('https://a.klaviyo.com/client/subscriptions' + q, {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: cfg.source || 'Pre-launch page',
            /* email only here; the first name rides on the event below (client/events takes profile fields) */
            profile: { data: { type: 'profile', attributes: {
              email: email,
              subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
            } } }
          },
          relationships: { list: { data: { type: 'list', id: cfg.listId } } }
        }
      }).then(function () {
        /* the launch emails trigger on this metric (the list is the shared Skincare list); the address
           is already on the list, so a failed event does not undo the sign-up */
        var params = new URLSearchParams(location.search);
        return post('https://a.klaviyo.com/client/events' + q, {
          data: {
            type: 'event',
            attributes: {
              properties: {
                source: cfg.source || '',
                page: location.pathname,
                utm_source: params.get('utm_source') || '',
                utm_campaign: params.get('utm_campaign') || '',
                utm_content: params.get('utm_content') || ''
              },
              metric: { data: { type: 'metric', attributes: { name: cfg.metric || 'Joined Launch Waitlist' } } },
              profile: { data: { type: 'profile', attributes: Object.assign({}, attrs, { properties: { launch_waitlist: true } }) } }
            }
          }
        }).catch(function () {});
      }).then(function () {
        if (window.klaviyo && typeof window.klaviyo.identify === 'function') { try { window.klaviyo.identify(attrs); } catch (x) {} }
        done(name);
      }, function () { shopifyFallback(name); });
    });
  }

  /* ---------- countdown ---------- */
  function startCount() {
    var box = document.querySelector('[data-pl-count]');
    var target = Date.parse(cfg.launchAt || '');
    if (!box || isNaN(target)) return;
    var els = { d: box.querySelector('[data-pl-d]'), h: box.querySelector('[data-pl-h]'), m: box.querySelector('[data-pl-m]'), s: box.querySelector('[data-pl-s]') };
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var left = Math.floor((target - Date.now()) / 1000);
      if (left <= 0) { box.hidden = true; clearInterval(timer); return; }
      els.d.textContent = pad(Math.floor(left / 86400));
      els.h.textContent = pad(Math.floor(left % 86400 / 3600));
      els.m.textContent = pad(Math.floor(left % 3600 / 60));
      els.s.textContent = pad(left % 60);
      box.hidden = false;
    }
    var timer = setInterval(tick, 1000);
    tick();
  }

  /* ---------- background video ---------- */
  function startVideo() {
    var vids = document.querySelectorAll('video[data-pl-video]');
    if (!vids.length || !window.matchMedia) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (navigator.connection && navigator.connection.saveData) return;
    var wide = matchMedia('(min-width: 990px)');
    function pick() {
      vids.forEach(function (v) {
        var on = (v.getAttribute('data-pl-video') === 'wide') === wide.matches;
        if (!on) { if (!v.paused) v.pause(); return; }
        if (!v.src) {
          v.muted = true; /* set as a property too, or some browsers refuse autoplay */
          v.addEventListener('playing', function () {
            v.classList.add('is-playing');
            if (v.parentNode) v.parentNode.classList.add('is-video');
          }, { once: true });
          v.src = v.getAttribute('data-src');
        }
        var p = v.play();
        if (p && p.catch) p.catch(function () {}); /* autoplay blocked (low power mode): the photo stays */
      });
    }
    pick();
    if (wide.addEventListener) wide.addEventListener('change', pick);
  }

  function init() {
    bindForm();
    startVideo();
    startCount();
    var back = /[?&]customer_posted=true/.test(location.search);
    var name = stored();
    if (back || name) showJoined(name && name !== '-' ? name : '', false);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
